module.exports = __webpack_public_path__ + "img/Marian_Wiatr.69886374.jpg";